import Instruction from "./Instruction";

/**
 * Execute a js async callback function, in it we can acces and edit any variables and do whatever we want with it.
 */
class Custom extends Instruction
{
	constructor(callback)
	{
		super();
		this.callback = callback;
	}
}

export default Custom
